/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Value4
 */
export interface Value4 {
}

/**
 * Check if a given object implements the Value4 interface.
 */
export function instanceOfValue4(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function Value4FromJSON(json: any): Value4 {
    return Value4FromJSONTyped(json, false);
}

export function Value4FromJSONTyped(json: any, ignoreDiscriminator: boolean): Value4 {
    return json;
}

export function Value4ToJSON(value?: Value4 | null): any {
    return value;
}

